// Fetch sunrise/sunset times from sunrise-sunset.org API
export async function fetchSunTimes(
  lat: number,
  lng: number,
  date: Date,
): Promise<{ sunrise: string; sunset: string } | null> {
  try {
    const dateStr = date.toISOString().split('T')[0]
    const response = await fetch(
      `https://api.sunrise-sunset.org/json?lat=${lat}&lng=${lng}&date=${dateStr}&formatted=0`,
    )
    const data = await response.json()

    if (data.status === 'OK') {
      // API returns UTC times, convert to local
      const sunriseUTC = new Date(data.results.sunrise)
      const sunsetUTC = new Date(data.results.sunset)

      const formatTime = (d: Date) => {
        const hours = d.getHours().toString().padStart(2, '0')
        const minutes = d.getMinutes().toString().padStart(2, '0')
        return `${hours}:${minutes}`
      }

      return {
        sunrise: formatTime(sunriseUTC),
        sunset: formatTime(sunsetUTC),
      }
    }
    return null
  } catch (error) {
    console.error('Failed to fetch sun times:', error)
    return null
  }
}
